export function dragFromAverages(item: { average: any }) {
  return item.average && item.average['CdAXWnNB_xG3'] && item.average['CdAXWnNB_xG3'][0];
}

export function dragFromDeltas(item: { deltas: any }) {
  return item.deltas && item.deltas['CdAXWnNB_xG3'] && item.deltas['CdAXWnNB_xG3'][0];
}
